"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Fetcher = void 0;
const collapseOptions = (options, includeCorsHeaders = true) => {
  const corsOptions = {
    mode: 'cors',
    credentials: 'include'
  };
  return {
    method: 'GET',
    ...(includeCorsHeaders && corsOptions),
    ...options
  };
};
const fetchWithTimeout = async (url, options = {}, fetch, logger) => {
  const {
    timeout = 30000
  } = options;
  const doFetch = new Promise(resolve => {
    try {
      fetch(url, options).then(res => resolve(res)).catch(e => {
        resolve({
          json: () => ({
            error: e.toString()
          })
        });
        logger({
          id: 'fetchError',
          error: e,
          message: 'error attempting to fetch',
          url,
          options
        });
      });
    } catch (error) {
      logger({
        id: 'fetchError',
        error,
        message: 'error attempting to fetch',
        url,
        options
      });
    }
  });
  return Promise.race([doFetch, new Promise((_resolve, reject) => {
    global.setTimeout(() => reject(new Error('call timeout')), timeout);
  })]);
};

/**
 * Fetcher function that returns wrappers for the fetch async/await and fetch Promise.
 * @param {Fetch} fetchInstance the fetch instance is passed in from instantiation
 * @returns {FetcherResult} FetcherResult interface object is returned
 */
const Fetcher = fetchInstance => {
  if (!fetchInstance) return console.error('fetch instance not found');
  const awaitFetch = async ({
    url = '',
    options = {},
    includeCorsHeaders,
    logger = () => {}
  }) => {
    const callOptions = collapseOptions(options, includeCorsHeaders);
    logger({
      id: 'fetch',
      message: 'attempting to fetch',
      url,
      callOptions
    });
    const response = await fetchWithTimeout(url, {
      ...callOptions
    }, fetchInstance, logger);
    logger({
      id: 'fetchResponse',
      response,
      message: 'fetch response recieved'
    });
    return await response.json();
  };
  const fetchPromise = ({
    url = '',
    options = {},
    includeCorsHeaders,
    logger = () => {}
  }) => {
    const callOptions = collapseOptions(options, includeCorsHeaders);
    logger({
      id: 'fetchPromise',
      log: 'attempting to fetchPromise',
      url,
      callOptions
    });
    return fetchWithTimeout(url, {
      ...callOptions
    }, fetchInstance, logger).catch(error => {
      logger({
        id: 'fetchPromiseError',
        error,
        message: 'error attempting to fetch',
        url,
        callOptions
      });
      throw error;
    });
  };
  return {
    fetch: awaitFetch,
    fetchPromise
  };
};
exports.Fetcher = Fetcher;
var _default = exports.default = Fetcher;